document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });
  });
});
